// Generated by CoffeeScript 2.3.2

import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import React from 'react';
;
var CurrentState, HeaderRow, Maybe, No, StateElement, StateRow, Yes;

Yes = function(props) {
  return <Icon>
    {(props.isAnswer ? "star" : "check_box")}
  </Icon>;
};

No = function() {
  return "";
};

Maybe = function() {
  return <Icon color="disabled">indeterminate_check_box</Icon>;
};

StateElement = function(props) {
  var card, player;
  ({card, player} = props);
  if (card.isHeldBy(player)) {
    return <Yes isAnswer={player === "ANSWER"} />;
  } else if (card.mightBeHeldBy(player)) {
    return <Maybe />;
  } else {
    return <No />;
  }
};

HeaderRow = function(props) {
  var playerId, players;
  ({players} = props);
  return <Grid container item xs={12} justify="center">
    <Grid item xs={4}><b>Card</b></Grid>
    {(function() {
    var results;
    results = [];
    for (playerId in players) {
      results.push(<Grid item key={playerId} xs={1}><b>{playerId}</b></Grid>);
    }
    return results;
  })()}
  </Grid>;
};

StateRow = function(props) {
  var card, playerId, players;
  ({card, players} = props);
  return <Grid container item xs={12} justify="center">
    <Grid item xs={4}>
      {(card.isHeldBy("ANSWER") ? <b> {card.info.name} </b> : card.info.name)}
    </Grid>
    {(function() {
    var results;
    results = [];
    for (playerId in players) {
      results.push(<Grid item key={playerId} xs={1}> 
          <StateElement card={card} player={playerId} /> 
        </Grid>);
    }
    return results;
  })()}
  </Grid>;
};

CurrentState = function(props) {
  var card, cards, id, players;
  ({cards, players} = props.solver);
  return <Grid container>
    <HeaderRow players={players} />
    {(function() {
    var results;
    results = [];
    for (id in cards) {
      card = cards[id];
      results.push(<StateRow key={id} card={card} players={players} />);
    }
    return results;
  })()}
  </Grid>;
};

export default CurrentState;
